<template>
    <div>
        <audio type="hidden" src="audio/alert.mp3"></audio>
        <div>
            <div class="w3-row"
                 v-bind:class="cls0">
                <div class="w3-col w3-twothird">
                    <content-header v-bind:title="$t(ftitle)"></content-header>
                </div>
                <div class="w3-col w-20pc w3-right flow-content-actions-header flow-margin-bottom  w3-margin-right">
                    <div class="w3-content flow-padding-top">
                        <div class="w3-row zero">

                            <div class="w3-col w3-quarter">
                                <span class="fa fa-stack w3-large cursor-pointer active w3-ripple flow-blue-color" @click="openFilters = !openFilters"
                                      :title="openFilters ? $t('hideFilters') : $t('showFilters')">
                                    <i class="fa fa-stack-2x fa-circle  w3-text-white" v-bind:class="openFilters ? 'halo-text' : ''"></i>
                                    <i class="fa fa-stack-1x fa-filter fa-inverse flow-blue-color w3-xlarge" v-bind:class="areFilterActive ? 'active-notification' : ''"></i>
                                </span>
                            </div>

                            <div class="w3-col w3-quarter">
                                <span v-if="fastTrackGroupId" id="patient-alert-icon" class="fa fa-stack w3-large cursor-pointer active w3-ripple flow-blue-color"
                                      :title="openPatientAlerts ? $t('hidePatientAlerts') : $t('openPatientAlerts')"
                                      @click="openPatientAlerts = !openPatientAlerts">
                                    <i class="fa fa-stack-2x fa-circle  w3-text-white" v-bind:class="openPatientAlerts ? 'halo-text' : ''"></i>
                                    <i class="fa fa-stack-1x fa-bell fa-inverse flow-blue-color w3-xlarge" v-bind:class="hasAlerts ? 'active-notification' : ''   "></i>
                                </span>
                            </div>

                            <div class="w3-col w3-quarter">
                                <span class="fa fa-stack w3-large cursor-pointer active w3-ripple flow-blue-color" @click="openNewPatient" :title="$t('addNewPatient')">
                                    <i class="fa fa-stack-2x fa-circle  w3-text-white"></i>
                                    <i class="fa fa-stack-1x fa-plus fa-inverse flow-blue-color w3-xlarge"></i>
                                </span>
                            </div>

                            <div class="w3-col w3-quarter">
                                <span class="fa fa-stack w3-large cursor-pointer active w3-ripple flow-blue-color"
                                      @click="openSearch"
                                      :title="$t('search')">
                                    <i class="fa fa-stack-2x fa-circle  w3-text-white"></i>
                                    <i class="fa fa-stack-1x fa-search fa-inverse flow-blue-color w3-xlarge"></i>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- CONTENT START -->
            <new-patient-main-card v-if="openNewPatientCard" :isFastTrackForm=isFastTrackForm :onClose="() => {openNewPatientCard = false;}"></new-patient-main-card>

            <div v-bind:style="{display: openNewPatientCard ? 'none' : 'block'}" class="w3-white w3-margin-bottom zero-top w3-animate-opacity" v-bind:class="cls1">

                <!-- MAIN CONTENT CARD START AKA LEFT CONTENT-->
                <div v-bind:class="cls2">

                    <!--PATIENT LIST + FILTERS START HERE-->
                    <filters v-bind:class="openFilters ? 'w3-show' : ''"
                             class="w3-hide w3-margin-bottom w3-animate-opacity green-top"
                             :onSave="updatePatientsOnFilterChange">
                    </filters>

                    <loading v-bind:dspin="displayLoading"></loading>

                    <div class="w3-animate-opacity" v-bind:style="{display: !displayLoading ? '' : 'none'}">
                        <patient-list
                                      :callbackOnPatientSelect="openPatient"
                                      :patients="patients"
                                      :selectedPatientId = "selectedPatient.id"
                                      :showMinimalView="isCardOpen"
                                      :preSelectedPatientId="activePatientId">
                        </patient-list>
                    </div>
                    <!--PATIENT LIST + FILTERS START HERE-->
                </div>

                <!--RIGHT CONTENT STARTS HERE = PATIENT INFO + NEW PATIENT -->
                <div v-if="openPatientCard" class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
                    <patient-side-card class="flow-padding-top"
                                       :selectedPatient="selectedPatient"
                                       :selectedPatientStatus="selectedPatient.status"
                                       :selectedPatientDevice="selectedPatient.device"
                                       :onClose="() => {openPatientCard = false; this.activePatientId = undefined}">
                    </patient-side-card>
                </div>

                <div v-if="fastTrackGroupId" v-show="openPatientAlerts" class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
                    <notify-patient-position-update :group="fastTrackGroupId"></notify-patient-position-update>
                </div>

            </div>

            <!-- CONTENT END -->
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import PatientInfo from "../components/patient/PatientInfo";
    import PatientAppt from "../components/patient/PatientAppointment";
    import PatientStatus from "../components/common/PatientStatus";
    import { EventBus } from "../main";
    import Filters from "../components/patient/Filters";
    import PatientList from "../components/patient/PatientList";
    import PatientPersonalData from "../components/patient/PatientPersonalData";
    import NewPatientCard from "../components/patient/NewPatientCard";
    import PatientSideCard from "../components/patient/PatientSideCard";
    import NewPatientMainCard from "../components/patient/NewPatientMainCard";
    import NotifyPatientPositionUpdate from "../components/patient/NotifyPatientPositionUpdate";

    const frc = Vue.prototype.$frc;

    export default {
        name: "Patients",
        components: {
            NotifyPatientPositionUpdate,
            NewPatientMainCard,
            PatientSideCard,
            NewPatientCard,
            PatientPersonalData,
            PatientList, Filters, PatientStatus, Loading, ContentHeader, PatientInfo, PatientAppt},
        props: ['ftitle'],
        data: function() {
            return {
                areFilterActive: false,
                openPatientCard: false,
                displayLoading: true,
                openNewPatientCard: false,
                patients: [],
                openFilters: false,
                selectedPatient : {},
                activePatientId: undefined,
                latestFilters: {},
                refreshIntervalId: undefined,
                openPatientAlerts: false,
                fastTrackGroupId: undefined,
                fastTrackWardId: undefined,
                isFastTrackForm: false,
                hasAlerts: false
            }
        },
        computed: {
            isCardOpen() {
                return this.openPatientCard || this.openNewPatientCard || this.openPatientAlerts;
            },
            patientHeading(){
                return Vue.patientNamePlusId(this.selectedPatient.name , this.selectedPatient.internalIds);
            },
            cls0() {
                if (!this.isCardOpen) return 'flow-margin-right';

                return 'content-sidebar-header ' + (this.openPatientAlerts ? 'sidebars-70-30' : 'sidebars-50-50');
            },
            cls1() {
                if (!this.isCardOpen) return 'w3-container flow-main-content';

                return 'w3-container content-sidebars ' + (this.openPatientAlerts ? 'sidebars-70-30' : 'sidebars-50-50');
            },
            cls2() {
                return this.isCardOpen ? 'zero w3-col content-sidebar-left' : 'zero w3-col w3-center';
            }
        },
        mounted() {
            EventBus.$on("wardUpdated", this.onWardUpdate);
            EventBus.$on("newPatientCreated", this.onNewPatientCreation);
            EventBus.$on("newPatientAlert", this.onPatientAlert);
            EventBus.$on("patientAlertsCount", this.onPatientAlertsCountChange);
            this.refreshIntervalId = setInterval(this.refreshPatients, 10000);
            this.setFastTrackProperties();
        },
        beforeDestroy() {
            EventBus.$off("wardUpdated", this.onWardUpdate);
            EventBus.$off("newPatientCreated", this.onNewPatientCreation);
            EventBus.$off("newPatientAlert", this.onPatientAlert);
            EventBus.$off("patientAlertsCount", this.onPatientAlertsCountChange);
            clearInterval(this.refreshIntervalId);
        },
        methods: {
            refreshPatients() {
                this.getPatientsForWard(this.latestFilters.phyIds, this.latestFilters.groupIds, this.latestFilters.statusIds, false);
            },
            openSearch (){
                this.$router.push('/search_add_new_patient');
            },
            onWardUpdate() {
                this.closeAllCards();
                this.displayLoading = true;
                this.setFastTrackProperties();
            },
            updatePatientsOnFilterChange(filters) {
                this.areFilterActive = filters.phyIds.length > 0 || filters.groupIds.length > 0 || filters.statusIds.length > 0;
                this.getPatientsForWard(filters.phyIds, filters.groupIds, filters.statusIds, true);

                this.latestFilters = filters;
            },
            getPatientsForWard(phyFilter, groupFilter, statusFilter, displayLoader) {
                const wardId = Vue.prototype.$currentWard.id;
                if (!wardId) {
                    Vue.notifyError({title: "No Ward Selection Made", message: "Cannot fetch patients without ward selection"});
                    return;
                }

                this.displayLoading = displayLoader;
                var app = this;
                console.log("Fetching Patients");
                frc.getPatientsForWard(wardId, phyFilter, groupFilter, statusFilter)
                    .then(function(res) {
                        app.patients = res.data;
                        app.displayLoading = false;
                    });
            },
            openNewPatient() {
                this.openNewPatientCard = true;
                this.openPatientCard = false;
                this.openPatientAlerts = false;
            },
            closeAllCards() {
                this.selectedPatient.id = undefined;
                this.openNewPatientCard = false;
                this.openPatientCard = false;
                this.openPatientAlerts = false;
            },
            closeNewPatientCard() {
                this.selectedPatient.id = undefined;
                this.openNewPatientCard = this.openPatientCard = false;
            },
            openPatient(patient) {
                this.openNewPatientCard = false;
                this.selectedPatient = patient;
                this.activePatientId = patient.id;
                this.openPatientCard = true;
                this.openPatientAlerts = false;
            },
            onNewPatientCreation(patientId) {
                this.closeAllCards();
                var app = this;
                frc.getPatient(patientId).then(function (res) {
                    app.openPatient(res.data);
                });

                this.updatePatientsOnFilterChange(this.latestFilters);
            },
            setFastTrackProperties() {
                var app = this;
                app.fastTrackGroupId = undefined;
                app.fastTrackWardId = undefined;

                frc.getApplicationSetting("UI", "fastTrackWardAndGroup").then(function (res) {
                    const wardAndGroup = Vue.extractFastTrackWardAndGroup(res.data, Vue.prototype.$currentWard.id);
                    console.log(wardAndGroup);
                    if (wardAndGroup[0] !== undefined) {
                        app.fastTrackWardId = wardAndGroup[0];
                        app.fastTrackGroupId = wardAndGroup[1];
                    }
                    app.isFastTrackForm = app.fastTrackWardId === Vue.prototype.$currentWard.id;
                });
            },
            onPatientAlert() {
                console.log("NEW ALERT!!");
                document.getElementsByTagName("audio")[0].play();
                document.getElementById("patient-alert-icon").classList.add("swing");
                this.hasAlerts = true;

                setTimeout(function () {
                    document.getElementById("patient-alert-icon").classList.remove("swing");
                }, 3000);

            },
            onPatientAlertsCountChange(count) {
                this.hasAlerts = count > 0;
            }
        }

    }

</script>

<style scoped>
    @-webkit-keyframes swing {
        0% {
            transform: rotate(20deg);
        }
        20% {
            transform: rotate(-20deg);
        }
        40% {
            transform: rotate(20deg);
        }
        60% {
            transform: rotate(-20deg);
        }
        80% {
            transform: rotate(20deg);
        }
        100% {
            transform: rotate(-20deg);
        }
    }

    .swing {
        -webkit-animation-name: swing;
        -webkit-animation-duration: 2s;
        -webkit-animation-iteration-count: 1;
        -webkit-animation-timing-function: ease-in-out;
    }

</style>